import styled from 'styled-components';
import { rgba } from 'polished';
import colors from '../../../../../../constants/colors';

import ProgramActivity from '../../../../../ProgramActivity';

const Wrapper = styled.div`
  margin-top: 4px;
  width: 100%;

  .slick-slide,
  .slick-slide * {
    outline: none !important;
  }

  .slick-slider {
    position: static;
  }

  .slick-list {
    padding-top: 10px;
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
  }

  .slick-slide {
    padding-left: 60px;
  }

  .slick-dots {
    position: absolute;
    bottom: 30px;

    li {
      margin: 0;
      margin-right: 9px;
      height: 8px;
      width: 8px;

      button {
        padding: 0;
        position: relative;
        height: 8px;
        width: 8px;

        &:before {
          background: ${rgba(colors.main.placeholdersAndDisabledBtnsText, 0.35)};
          border-radius: 50%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          content: '';
          height: 8px;
          width: 8px;
        }
      }

      &.slick-active {
        button {
          &:before {
            background: ${colors.main.placeholdersAndDisabledBtnsText};
          }
        }
      }
    }
  }

  @media screen and (max-width: 992px) {
    width: 100;

    .slick-dots {
      display: none !important;
    }

    .slick-slide {
      padding-left: 52px;
    }
  }
`;

const StyledProgramActivity = styled(ProgramActivity)`
  display: block;
  cursor: pointer;
  padding: 15px 30px;
  position: relative;
  z-index: 10;

  span {
    &:first-of-type {
      display: none;
    }
  }

  &:before {
    background: #f8f9fa;
    content: '';
    position: absolute;
    left: -30px;
    top: -2px;
    right: 0;
    bottom: -2px;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: -1;
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }

  &:nth-of-type(1),
  &:nth-of-type(2) {
    padding-top: 18px;
  }

  &:nth-of-type(2) {
    border-top: 1px solid ${colors.main.dividers};
  }

  @media screen and (max-width: 992px) {
    padding: 10px 20px;
  }
`;

export { Wrapper, StyledProgramActivity };
